import {
  LimitKind,
  LimitsClientProtobuf,
  LimitsClientJSON,
} from "@smartsuite/limits-engine-api";
import type {
  GetLimitsResponse,
  LimitsClient,
} from "@smartsuite/limits-engine-api";
import React from "react";
import type { FetchRPCOptions } from "@smartsuite-foundry/twirp-ts";
import { FetchRPC } from "@smartsuite-foundry/twirp-ts";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../stores/hooks";

class LimitsEngineClient {
  constructor(private readonly client: LimitsClient) {}

  async getLimits(): Promise<GetLimitsResponse> {
    return await this.client.GetLimits({ kind: LimitKind.AUTOMATION_ACTION });
  }
}

const LimitsClientContext = React.createContext(
  new LimitsEngineClient(
    new (window.sessionStorage.JSON_RPC === "1"
      ? LimitsClientJSON
      : LimitsClientProtobuf)(
      FetchRPC({
        baseUrl: new URL("/", window.location.href).href,
        credentials: "include",
      }),
    ),
  ),
);

export const useLimitsClient = (): LimitsEngineClient =>
  React.useContext(LimitsClientContext);

export const LimitsClientProvider = observer<{
  children: React.ReactNode;
}>(({ children }) => {
  const rootStore = useRootStore();

  const headers: FetchRPCOptions["headers"] = {
    "account-id": rootStore.config.accountId,
  };

  if (rootStore.config.accessToken !== undefined) {
    headers["access-token"] = rootStore.config.accessToken;
  }

  const limitsClient = new LimitsEngineClient(
    new (window.sessionStorage.JSON_RPC === "1"
      ? LimitsClientJSON
      : LimitsClientProtobuf)(
      FetchRPC({
        baseUrl: rootStore.config.limitsUrl,
        headers,
        credentials: "include",
      }),
    ),
  );

  return (
    <LimitsClientContext.Provider value={limitsClient}>
      {children}
    </LimitsClientContext.Provider>
  );
});
